import { render } from "./PropertyLeasehold.vue?vue&type=template&id=1c371fdc"
import script from "./PropertyLeasehold.vue?vue&type=script&lang=js"
export * from "./PropertyLeasehold.vue?vue&type=script&lang=js"

import "./PropertyLeasehold.vue?vue&type=style&index=0&id=1c371fdc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__